module.exports = __webpack_public_path__ + "img/incoelectric.16ea31a0.png";